export default __webpack_public_path__ + "static/media/Core-banking.2aab7bf7.jpg";